module.exports = __webpack_public_path__ + "img/22.e9234487.png";